export default [
  {
    path: '/shop',
    name: 'shop',
    component: () => import('@/views/Shop/index'),
    children: [
      {
        name: 'sale',
        component: () => import('@/views/Shop/list'),
      },
      {
        name: 'rent',
        component: () => import('@/views/Shop/list'),
      },
      {
        name: 'first-sale',
        component: () => import('@/views/Shop/list'),
      },
      {
        name: 'first-rent',
        component: () => import('@/views/Shop/list'),
      },
      {
        name: 'building-detail', //一手项目详情
        component: () => import('@/views/Office/buildingDetail'),
      },
      {
        name: 'house-detail',
        component: () => import('@/views/Office/houseDetail'),
      },
      {
        name: 'room-detail',
        component: () => import('@/views/Office/roomDetail'),
      },
      {
        name: 'first-detail',
        component: () => import('@/views/Office/houseDetail'),
      },
      {
        name: 'edifice-detail', //大厦详情
        component: () => import('@/views/Office/buildingDetail'),
      },
    ],
  },
];
